import { ThemeOptions } from '@mui/material/styles';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { text } from 'stream/consumers';

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
      fantasy: true;
    }
  }

export const colors = {
    primary : '#ffffff',
    secundary: '#b2b1b6ff',
    background : '#353536ff',
    text: '#F1E8E0',
    text_secondary: '#9b9a9e',
    popup: '#cedfeeec'
}

const themeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: colors.primary,  
      dark:  colors.primary
    },
    secondary: {
      main: colors.secundary,
      dark: colors.secundary 
    },
    background:{
      paper: colors.background  
    },
    text:{
      primary: colors.text,      
      secondary: colors.text_secondary
    }
  },
  components:{
    MuiButton:{
    },
    MuiMenu:{
      styleOverrides:{
        list:{
          backgroundColor: colors.background
        }
      }
    },
    MuiDrawer:{
        styleOverrides:{
            paper:{
                backgroundColor: colors.background,
                color: colors.text,
                textAlign: 'center'            
            },
            modal:{
                color: '#ffffff',
                backgroundColor: colors.background
            }                                   
        }      
    },
    MuiTypography:{
        variants:[
            {
                props: { variant:'fantasy' },
                style: {
                  fontFamily: 'fantasy'                  
                },
              },
        ]
    }    
  }
};

const theme = createTheme(themeOptions);

export default theme;